export default "__VITE_ASSET__B7bU6gIA__"